var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConatctLocatonIconStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3552_23473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52388 7.47547C6.2573 7.66535 4.54686 6.46174 4.21927 6.4591C3.89168 6.45648 2.16197 7.63239 1.89851 7.43825C1.63505 7.24412 2.25444 5.25007 2.15573 4.9386C2.05702 4.62713 0.400937 3.35012 0.504675 3.04027C0.608436 2.73041 2.70168 2.70163 2.96826 2.51176C3.23483 2.32191 3.94103 0.356755 4.26864 0.359378C4.59621 0.362023 5.27051 2.33828 5.53397 2.53242C5.79743 2.72654 7.88997 2.78902 7.9887 3.10049C8.08741 3.41196 6.4109 4.66216 6.30714 4.97201C6.2034 5.28186 6.79045 7.2856 6.52388 7.47547Z",
    fill: "url(#paint0_linear_3552_23473)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3552_23473",
    x1: 0.50001,
    y1: 3.92759,
    x2: 7.99289,
    y2: 3.92759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3552_23473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConatctLocatonIconStar);
export default __webpack_public_path__ + "static/media/Conatct-locaton-icon-star.a07f7188a77a8cde008cd1fbd65a3cb3.svg";
export { ForwardRef as ReactComponent };